import { Modal, Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";

const RenameModal = ({ show, handleClose, handleRename, item }) => {
  const [newName, setNewName] = useState(null);
  useEffect(() => {
    if (show) {
      setNewName(item.name);
    }
  }, [show]);

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>Rename Variant</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Control
          type="text"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={() => handleRename(newName)}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RenameModal;
